import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
// Third party packages
import { MatDialog, MatDialogRef } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { take } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { ActivationsService } from "src/app/modules/settings/activations.service";
import { ActivationEditDialogComponent } from 'src/app/modules/settings/components/activation-edit-dialog/activation-edit-dialog.component';
import { SettingsService } from "src/app/modules/settings/settings.service";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
/**
 * Script start
 */
var ActivationListDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function ActivationListDialogComponent(dialogRef, data, dialog, configService, translateService, authService, cookieService, toastrService, helperService, settingsService, activationsService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.dialog = dialog;
        this.configService = configService;
        this.translateService = translateService;
        this.authService = authService;
        this.cookieService = cookieService;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.settingsService = settingsService;
        this.activationsService = activationsService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.dialogIsLoading = true; // Used to view/hide form loading spinner
        this.title = "";
        this.activations = [];
        this.activationItems = [];
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.fieldGroup = [];
        // BEGIN - Edit item form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.subForm = new FormGroup({});
        this.newSubForm = new FormGroup({});
        this.model = {};
        this.subModel = {};
        this.newSubModel = {};
        this.fields = [];
        this.subFields = [];
        this.newSubFields = [];
        this.options = {};
        this.subOptions = {};
        this.newSubOptions = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    ActivationListDialogComponent.prototype.ngOnInit = function () {
        if (this.data.item &&
            this.data.item.formConfig &&
            Array.isArray(this.data.item.formConfig) &&
            this.data.item.formConfig.length === 1 &&
            this.data.item.formConfig[0].fieldGroup &&
            Array.isArray(this.data.item.formConfig[0].fieldGroup)) {
            this.title = this.data.item.translation.it;
            this.fieldGroup = this.data.item.formConfig[0].fieldGroup;
        }
        this.getSectionActivations();
    };
    /**
     * Get activation of section: es "anagrafica"
     */
    ActivationListDialogComponent.prototype.getSectionActivations = function () {
        var _this = this;
        this.activations = [];
        this.activationItems = [];
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.subscriptions.push(this.settingsService.getDocument().subscribe(function (res) {
            if (res.status) {
                if (res.data &&
                    Array.isArray(res.data) &&
                    res.data.length > 0 &&
                    res.data[0].area &&
                    Array.isArray(res.data[0].area)) {
                    _this.documentTemplateId = res.data[0]._id;
                    _this.documentTemplate = res.data[0].area;
                }
            }
            var key = _this.data.item.key;
            if (_this.data && _this.data.item && _this.data.item.key) {
                _this.subscriptions.push(_this.activationsService.getList(0, 100, 'structure', 'desc', { 'structure': _this.data.item.key })
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.activations = res.data.items;
                        if (_this.activations && Array.isArray(res.data.items)) {
                            _this.activations.forEach(function (item) {
                                var fields = '';
                                var docs = '';
                                var fireActivation = '';
                                var nameDocs = '';
                                if (item.fields && Array.isArray(item.fields)) {
                                    item.fields.forEach(function (field) {
                                        var index = _this.fieldGroup.findIndex(function (el) { return el.key === field.name; });
                                        if (index > -1) {
                                            if (_this.fieldGroup[index].templateOptions &&
                                                _this.fieldGroup[index].templateOptions.translationLabel &&
                                                _this.fieldGroup[index].templateOptions.translationLabel.it) {
                                                var value_1 = field.value;
                                                if (_this.fieldGroup[index].templateOptions.options &&
                                                    Array.isArray(_this.fieldGroup[index].templateOptions.options)) {
                                                    var subIndex = _this.fieldGroup[index].templateOptions.options.findIndex(function (subEl) { return subEl.value === value_1; });
                                                    if (subIndex > -1 &&
                                                        _this.fieldGroup[index].templateOptions.options[subIndex].translation &&
                                                        _this.fieldGroup[index].templateOptions.options[subIndex].translation.it) {
                                                        value_1 = _this.fieldGroup[index].templateOptions.options[subIndex].translation.it;
                                                    }
                                                }
                                                fields = "" + fields + _this.fieldGroup[index].templateOptions.translationLabel.it + " " + field.operation + " " + value_1 + "<br>";
                                            }
                                        }
                                    });
                                }
                                if (item.docs && Array.isArray(item.docs)) {
                                    item.docs.forEach(function (doc) {
                                        var e_1, _a, e_2, _b;
                                        // if (doc.key && Array.isArray(doc.key)) {
                                        //   doc.key.forEach((key: any) => {
                                        //     nameDocs = `${nameDocs}${key.name} `;
                                        //   });
                                        // }
                                        if (doc.activationType && doc.activationType !== '') {
                                            fireActivation = " (" + doc.activationType + ")";
                                        }
                                        var docName = doc.name;
                                        var found = false;
                                        if (_this.documentTemplate &&
                                            Array.isArray(_this.documentTemplate)) {
                                            try {
                                                for (var _c = tslib_1.__values(_this.documentTemplate), _d = _c.next(); !_d.done; _d = _c.next()) {
                                                    var docsTemplate = _d.value;
                                                    var content = docsTemplate.content;
                                                    if (content && Array.isArray(content)) {
                                                        var _loop_1 = function (subDocs) {
                                                            var title = subDocs.title.replace('properties.documents.', '');
                                                            if (title === doc.name) {
                                                                found = true;
                                                                docName = subDocs.translation.it;
                                                                doc.translation = subDocs.translation;
                                                                var documents_1 = subDocs.documents;
                                                                if (documents_1 && Array.isArray(documents_1)) {
                                                                    nameDocs = '';
                                                                    if (doc.keys && Array.isArray(doc.keys)) {
                                                                        doc.keys.forEach(function (key) {
                                                                            var docIndex = documents_1.findIndex(function (el) { return el.key === key; });
                                                                            if (docIndex > -1) {
                                                                                nameDocs = nameDocs + " - " + documents_1[docIndex].translation.it + "<br>";
                                                                                // key.translation = documents[docIndex].translation;
                                                                            }
                                                                        });
                                                                    }
                                                                }
                                                            }
                                                            if (found) {
                                                                return "break";
                                                            }
                                                        };
                                                        try {
                                                            for (var content_1 = (e_2 = void 0, tslib_1.__values(content)), content_1_1 = content_1.next(); !content_1_1.done; content_1_1 = content_1.next()) {
                                                                var subDocs = content_1_1.value;
                                                                var state_1 = _loop_1(subDocs);
                                                                if (state_1 === "break")
                                                                    break;
                                                            }
                                                        }
                                                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                                        finally {
                                                            try {
                                                                if (content_1_1 && !content_1_1.done && (_b = content_1.return)) _b.call(content_1);
                                                            }
                                                            finally { if (e_2) throw e_2.error; }
                                                        }
                                                    }
                                                    if (found) {
                                                        break;
                                                    }
                                                }
                                            }
                                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                            finally {
                                                try {
                                                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                                                }
                                                finally { if (e_1) throw e_1.error; }
                                            }
                                        }
                                        docs = "" + docs + docName + fireActivation + ": <br> " + nameDocs;
                                    });
                                }
                                _this.activationItems.push({
                                    id: item._id,
                                    fields: fields,
                                    docs: docs,
                                });
                            });
                        }
                    }
                    _this.dialogIsLoading = false;
                }, function (err) {
                    _this.helperService.handleError(err);
                    _this.dialogIsLoading = false;
                }));
            }
        }, function (err) {
            _this.helperService.handleError(err);
            _this.dialogIsLoading = false;
        }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    ActivationListDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle new activation
     *
     * @since 1.0.0
     */
    ActivationListDialogComponent.prototype.onNew = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ActivationEditDialogComponent, {
            data: {
                new: true,
                structure: this.data.item.title.replace('properties.structures.', ''),
                documentTemplate: this.documentTemplate,
                fieldGroup: this.fieldGroup,
            },
            width: "98%",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (res) {
                _this.dialogIsLoading = true;
                _this.getSectionActivations();
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handle edit activation
     *
     * @since 1.0.0
     */
    ActivationListDialogComponent.prototype.onEdit = function (id) {
        var _this = this;
        var activations = this.activations.filter(function (el) { return el._id.toString() === id.toString(); });
        var dialogRef = this.dialog.open(ActivationEditDialogComponent, {
            data: {
                new: false,
                structure: this.data.item.title.replace('properties.structures.', ''),
                id: id,
                activations: Array.isArray(activations) && activations.length ? activations[0] : [],
                documentTemplate: this.documentTemplate,
                fieldGroup: this.fieldGroup,
            },
            width: "98%",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (res) {
                _this.dialogIsLoading = true;
                _this.getSectionActivations();
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handle delete activation
     *
     * @since 1.0.0
     */
    ActivationListDialogComponent.prototype.onDelete = function (id) {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant('settings.activation.dialog.delete.title'),
                message: this.translateService.instant('settings.activation.dialog.delete.message'),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant('common.cta.close'),
            },
            width: '500px',
            disableClose: true
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (res) {
                _this.activationsService.delete(id)
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.toastrService.success(res.message);
                        _this.dialogIsLoading = true;
                        _this.getSectionActivations();
                    }
                }, function (err) {
                    _this.helperService.handleError(err);
                    _this.dialogIsLoading = false;
                });
            }
        });
    };
    /**
     * Handle dialog denial
     *
     * @since 1.0.0
     */
    ActivationListDialogComponent.prototype.onClose = function (data) {
        this.dialogRef.close();
    };
    return ActivationListDialogComponent;
}());
export { ActivationListDialogComponent };
